/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-27 09:51:29
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-12 15:20:10
 * @FilePath: /chaoyongtuan/src/views/shopManage/tagManagement/list/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ColumnTypes from '@/utils/ColumnTypes';
function getColums(activeName) {
	let arr = [
		{
			key: 'tag_name',
			label: '标签名称',
			minWidth: 150,
			type: () => import('./components/tableCell/tagCell.vue'),
		},
		{
			key: 'tag_use_count',
			label: activeName == '2' ? '样品数量' : '商品数量',
			minWidth: 150,
			type: () => import('./components/tableCell/goodsNum.vue'),
		},
		{
			key: 'add_time',
			label: '创建时间',
			type: ColumnTypes.TextCell,
			minWidth: 150,
		},
		{
			key: 'operations',
			label: '操作',
			type: ColumnTypes.ButtonsCell,
			minWidth: '100',
		},
	];
	return arr;
}

export default getColums;
